export function isUnexpectedLoginLanding({
  targetUrl,
  finalUrl,
}: {
  targetUrl: string;
  finalUrl: string;
}): boolean {
  try {
    const target = new URL(targetUrl);
    const final = new URL(finalUrl);

    if (target.origin !== final.origin) {
      return false;
    }

    const loginPathPattern = /\/login(\/|$)/i;

    if (!loginPathPattern.test(final.pathname)) {
      return false;
    }

    if (loginPathPattern.test(target.pathname)) {
      return false;
    }

    return true;
  } catch {
    return false;
  }
}
